/**
 * Core Blockchain explorer — build explorer URLs from a base URL supplied by the backend (GET /api/config/client).
 * Paths: /tx/{hash}, /address/{addr}, /token/{contract}/instance/{tokenId} (Blockscout ERC-721/1155 instance page).
 */

import { toCoreDisplayAddress } from '../blockchain/coreIcanAddress';

export function trimExplorerBase(url) {
  return String(url || '').replace(/\/+$/, '');
}

export function explorerTransactionUrl(baseUrl, transactionHash) {
  const base = trimExplorerBase(baseUrl);
  const h = String(transactionHash || '').trim();
  if (!base || !h) return '';
  return `${base}/tx/${encodeURIComponent(h)}`;
}

export function explorerAddressUrl(baseUrl, address) {
  const base = trimExplorerBase(baseUrl);
  const raw = String(address || '').trim();
  if (!base || !raw) return '';
  const a = toCoreDisplayAddress(raw) || raw;
  return `${base}/address/${encodeURIComponent(a)}`;
}

export function explorerTokenUrl(baseUrl, contractAddress, tokenId) {
  const base = trimExplorerBase(baseUrl);
  const raw = String(contractAddress || '').trim();
  const c = (raw ? toCoreDisplayAddress(raw) : '') || raw;
  const t = String(tokenId ?? '').trim();
  if (!base || !c) return '';
  // Blockscout (e.g. localhost:4080) uses /token/{addr}/instance/{id}, not /token/{addr}/{id}
  if (!t) {
    return `${base}/token/${encodeURIComponent(c)}`;
  }
  return `${base}/token/${encodeURIComponent(c)}/instance/${encodeURIComponent(t)}`;
}
